package uz.ferro.erp.model

import kotlinx.serialization.Serializable

@Serializable
data class AuthBody(
    val username: String? = null,
    val password: String? = null,
    val externalToken: String? = null
)
